import {Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Subscription} from 'rxjs';
import {DocumentsApiService} from '../../../../services/api/documents-api.service';

@Component({
    selector: 'app-component-search-collection',
    templateUrl: './search-collection.component.html',
    styleUrls: ['./search-collection.component.scss']
})
export class SearchCollectionComponent implements OnInit, OnDestroy {

    public value = new FormControl();
    public subscription: Subscription;
    public selected = null;
    public results = [];
    @ViewChild('input') private input: ElementRef;
    @ViewChild('search_hints') private search_hints: ElementRef;
    @Output() private data: EventEmitter<any> = new EventEmitter<any>();
    @Output() private item: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        protected documentApi: DocumentsApiService
    ) {
    }

    ngOnInit(): void {
        this.subscription = this.value.valueChanges
            .subscribe(next => {
                if (!this.selected && next) {
                    this.documentApi.search({title: next, instance_type: 'collection'}).subscribe({
                        next: data => {
                            this.input.nativeElement.classList.remove('error');
                            this.results = data.results;
                        }, error: () => {
                            this.results = [];
                            this.input.nativeElement.classList.add('error');
                        }
                    });
                }
            });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    select(item): void {
        this.selected = item;
        this.value.patchValue(item.name);
        this.value.disable();
        this.results = [];
        this.data.emit(item.id);
        this.item.emit(item);
    }

    remove(): void {
        this.selected = null;
        this.value.patchValue('');
        this.value.enable();
        this.input.nativeElement.focus();
    }

    arrowSelector(): void {
        this.search_hints.nativeElement.focus();
    }
}
